export type PitchDeck3Slide = {
  id: string
  label: string
  title: string
  subtitle?: string
  dark?: boolean
  bubbles?: boolean
  divider?: boolean
}

export const convenienceStoreImage =
  'https://cdn.magicpatterns.com/uploads/5miQXbzRGrx6AbuDP9jTCA/C-STORE.jpg'

export const cafeImage =
  'https://cdn.magicpatterns.com/uploads/28T1xh19SKbkjm8zLEXFhX/Cafe-.jpg'

export const educationImage =
  'https://cdn.magicpatterns.com/uploads/14DnUg6khjSybJ4RFF4wTo/Education.jpg'

export const restaurantImage =
  'https://cdn.magicpatterns.com/uploads/eQoKFfzptULtFRicL4M83a/restaurants-new.jpg'

export const spaImage =
  'https://cdn.magicpatterns.com/uploads/4ZRaehaz6PZH2NP5o1qCHB/SPA.jpg'

export const workplaceImage =
  'https://cdn.magicpatterns.com/uploads/6gLpu3N8NRhdUisKFenxW2/workplace-1.jpg'

export const pitchDeck3Slides: PitchDeck3Slide[] = [
  /* Act 1 — The thesis */
  {
    id: 'cover',
    label: 'SmartSoda Holdings Inc.',
    title: 'The Beverage Network',
    subtitle: 'Connecting every place where people drink.',
    dark: true,
    bubbles: true,
  },

  /* Legal */
  {
    id: 'disclaimer',
    label: 'Disclaimer',
    title: 'Confidential — disclaimer and forward-looking statements.',
  },
  {
    id: 'networks',
    label: 'The network shift',
    title: 'Every industry eventually becomes a network.',
    subtitle: 'Beverages remain a physical-product system. SmartSoda is building the connected layer.',
  },
  {
    id: 'broken-distribution',
    label: 'The old model',
    title: 'Today’s beverage system moves too much before the drink reaches a person.',
    subtitle: 'Packaging, freight, storage, refrigeration, waste, and retail handling surround every serving.',
  },
  {
    id: 'market',
    label: 'Market hierarchy',
    title: 'One of the world’s largest consumer systems is still largely unmanaged.',
    subtitle: 'The opportunity starts with beverage demand and reaches into everyday locations.',
  },
  {
    id: 'why-now',
    label: 'Why now',
    title: 'The ingredients for a beverage network have converged.',
    subtitle: 'What could not be assembled ten years ago can now be deployed as connected infrastructure.',
  },

  /* Act 2 — What we built */
  {
    id: 'juli',
    label: 'JuLi 5.0',
    title: 'JuLi 5.0 is a network node — not simply a dispenser.',
    subtitle: 'Each endpoint can bring together the drink, the location, and the relationship.',
    dark: true,
    bubbles: true,
  },
  {
    id: 'hydration-platform',
    label: 'Beverage choice platform',
    title: 'JuLi 5.0 turns one endpoint into an expansive beverage program.',
    subtitle: 'Flavors, functional enhancements, mineral water, coffee, and tea can all evolve around one compact platform.',
    dark: true,
    bubbles: true,
  },
  {
    id: 'product-system',
    label: 'Product system',
    title: 'JuLi 5.0 brings hardware, consumables, and connectivity into one operating system.',
    subtitle: 'Management-provided product architecture highlights a compact microdose delivery system, RFID-enabled consumables, and an integrated countertop platform.',
    dark: true,
  },
  {
    id: 'microdose',
    label: 'Microdose economics',
    title: 'Make the beverage system smaller, smarter, and easier to manage.',
    subtitle: 'Microdose architecture is designed to replace bulky beverage logistics with a compact, cloud-managed system.',
  },

  /* Act 3 — Proof */
  {
    id: 'distribution-network',
    label: 'Go-to-market advantage',
    title: 'Four years of industry partnerships create an accelerated path to market.',
    subtitle: 'JuLi™ 1.0 established SmartSoda across foodservice, OCS, vending, and distribution—creating commercial traction, strategic partnerships, and an initial Compass Group/Canteen purchase order for 500 JuLi™ systems.',
    dark: true,
  },
  {
    id: 'proof',
    label: 'Market credibility',
    title: 'Credibility in the market. Value at the point of drink.',
    subtitle: 'Featured organizations and SmartSoda value signals, as presented on SmartSoda.com.',
  },
  {
    id: 'sip',
    label: 'SIP — SmartSoda Intelligence Platform',
    title: 'We sell to facilities once. We acquire the entire workforce.',
    subtitle: 'SIP — the SmartSoda Intelligence Platform — turns one signed install into hundreds of named, engaged members. Every prompt drives another pour, every pour improves hydration the employer can measure, and every saved recipe raises the cost of ever taking JuLi™ out of the building.',
  },
  {
    id: 'vision',
    label: 'The network vision',
    title: 'One beverage relationship, across every day and every place.',
    subtitle: 'Imagine a single hydration subscription that follows a person from the gym to the office to the couch — every JuLi endpoint on the network honoring the same membership.',
  },

  /* Act 4 — The economics */
  {
    id: 'financial-model',
    label: 'Operating model',
    title: 'The financial model is built around deployed endpoints and recurring operating relationships.',
    subtitle: 'Hardware deployment, consumables, software, service, and payment-ready tooling form the management framework for validating unit economics.',
    dark: true,
  },
  {
    id: 'financial-highlights',
    label: 'Financial highlights',
    title: 'Financial highlights — equipment opens the door, consumables build the business.',
    subtitle: 'Five-year plan, 2027–2031, USD Mn. Roughly 72% of revenue comes from consumables.',
    dark: true,
  },

  /* Act 5 — The ask */
  {
    id: 'valuation-layers',
    label: 'Why a premium is warranted',
    title: 'Three businesses. One platform.',
    subtitle: 'Hardware, recurring commerce, and enterprise intelligence stack on the same installed node.',
  },
  {
    id: 'valuation-multiple',
    label: 'Valuation credibility',
    title: 'A hybrid platform deserves a hybrid multiple.',
    subtitle: 'Benchmarked against connected hardware, connected commerce, pure software, and the beverage-platform precedents that came before us.',
  },
  {
    id: 'funding-history',
    label: 'Funding history',
    title: 'Six years. $10M raised. Every round priced against progress.',
    subtitle: 'From founding in 2019 through JuLi™ 5.0 and SIP — valuation has stepped up as milestones were delivered.',
    dark: true,
    bubbles: true,
  },
  {
    id: 'use-of-funds',
    label: 'Use of funds',
    title: 'Every dollar of the $5M is deployed against the 2027 plan.',
    subtitle: 'Working capital, people, and balance-sheet strength — the three things standing between committed orders and recurring consumables revenue.',
    dark: true,
  },
  {
    id: 'valuation-roadmap',
    label: 'Earning the next multiple',
    title: 'How we earn higher valuations.',
    subtitle: 'Each step up is tied to milestones that must be proven, not projected.',
  },

  /* Act 6 — Close */
  {
    id: 'team',
    label: 'Leadership team',
    title: 'Leadership coverage across the system: beverage, technology, business development, and board perspective.',
    subtitle: 'Roles and names reflect company-management materials supplied for this presentation.',
    dark: true,
  },
  {
    id: 'closing',
    label: 'Closing',
    title: 'The Beverage Network: connected wherever people drink.',
    dark: true,
    bubbles: true,
  },

  /* Appendix */
  {
    id: 'appendix-divider',
    label: 'Appendix',
    title: 'Diligence appendix',
    subtitle: 'Supporting product, operating, market, and competitive detail.',
    dark: true,
    bubbles: true,
    divider: true,
  },
  {
    id: 'moat',
    label: 'Complete-system moat',
    title: 'The defensibility is in the system — and how the layers connect.',
    subtitle: 'No single component creates the network. The compounding system does.',
  },
  {
    id: 'financial-outlook',
    label: 'Financial outlook',
    title: 'Capital is designed to move the business from deployment to scale.',
    subtitle: 'Management’s illustrative funding and liquidity framing is presented as a planning view—not a forecast or external market fact.',
    dark: true,
  },
  {
    id: 'deployment-engine',
    label: 'Deployment engine',
    title: 'Every installation can become a monitored, replenished, and continuously improved operating relationship.',
    subtitle: 'A repeatable delivery model connects site design, activation, remote monitoring, service, and optimization across the installed base.',
  },
  {
    id: 'ai',
    label: 'AI opportunity',
    title: 'The intelligence layer grows with the physical network.',
    subtitle: 'Opportunity areas span consumer experiences, enterprise operations, and partner tools.',
  },

  /* Additional strategic vision */
  {
    id: 'strategic-vision-divider',
    label: 'Additional Strategic Vision',
    title: 'Optional strategic vision',
    subtitle: 'Longer-term platform framing for discussion when investors want to explore the full opportunity.',
    dark: true,
    bubbles: true,
    divider: true,
  },
  {
    id: 'wedge',
    label: 'Distribution wedge',
    title: 'Enterprise is not the end market. Enterprise is distribution.',
    subtitle: 'The workplace creates daily usage, identity, and a path to consumer relationships beyond the workplace.',
  },
  {
    id: 'flywheel',
    label: 'The flywheel',
    title: 'Every new node can make the network more useful.',
    subtitle: 'Physical reach becomes usage, knowledge, product improvement, and stronger distribution over time.',
    dark: true,
    bubbles: true,
  },
  {
    id: 'revenue',
    label: 'Revenue engine',
    title: 'One endpoint can support multiple layers of value creation.',
    subtitle: 'As the relationship moves closer to the consumer, the potential value layers broaden.',
  },
  {
    id: 'workplace-shift',
    label: 'The workplace beverage platform',
    title: 'The workplace has changed. The break room hasn’t.',
    subtitle: 'The most visited room in the building still runs on six machines, six vendors, and six service schedules.',
  },
  {
    id: 'workplace-platform',
    label: 'Category creation',
    title: 'Introducing the Workplace Beverage Platform.',
    subtitle: 'Not equipment with software attached — software, service, and hospitality wrapped around premium beverage delivery.',
    dark: true,
    bubbles: true,
  },
  {
    id: 'workplace-stakeholders',
    label: 'Every decision maker',
    title: 'One platform. Five different reasons to say yes.',
    subtitle: 'HR, facilities, finance, operations, and the CEO each evaluate the break room differently — the platform answers all five.',
  },

  /* Contact */
  {
    id: 'contact',
    label: 'Contact us',
    title: 'Young America Capital, LLC',
  },
]
